import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useState } from 'react';

export const Element = styled.button`
    min-width: 94px;
    height: 32px;
    border: 1px solid var(--gray200);
    background-color: var(--gray50);
    border-radius: 16px;
    box-shadow: inset var(--shadow-2);
    outline: none;
    cursor: pointer;
    vertical-align: middle;
    pointer-events: none;

    -webkit-tap-highlight-color: transparent;

    :hover {
        border: 1px solid var(--gray800);
    }

    :disabled {
        border: 1px solid var(--gray200);
        box-shadow: none;
        cursor: initial;
    }

    :focus {
        box-shadow: var(--outline);
    }

    :active {
        box-shadow: inset var(--shadow-2);
        border: 1px solid var(--blue400);
    }

    ${(props) =>
        props.isOver &&
        css`
            box-shadow: var(--outline);
            background-color: var(--color-white);
        `}

    ${(props) =>
        props.selected &&
        css`
            border: 1px solid var(--blue500);
            box-shadow: inset var(--shadow-2);
        `}
`;

const EasyDrop = styled.span`
    margin: -8px -32px;
    padding: 8px 32px;
`;

const Gap = ({ disabled = false, idRef, selected = false, onClick }) => {
    const [isDropTarget, setIsDropTarget] = useState(false);

    const onDragEnter = (evt) => {
        evt.preventDefault();
        setIsDropTarget(true);
    };

    const onDragLeave = (evt) => {
        evt.preventDefault();
        setIsDropTarget(false);
    };

    const onDrop = (evt) => {
        onClick();
    };

    return (
        <EasyDrop
            onClick={onClick}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={(evt) => evt.preventDefault()}
            onDrop={onDrop}
        >
            <Element disabled={disabled} idRef={idRef} selected={selected} isOver={isDropTarget} />
        </EasyDrop>
    );
};

Gap.propTypes = {
    disabled: PropTypes.bool,
    idRef: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Gap;
